<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <span class="w-title">合同管理</span>
    <v-divider class="my-3"/>

    <v-container fluid grid-list-md class="xn-form pa-0">
      <v-layout wrap>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filters.province"
            no-data-text="无可用数据"
            label="省份"
            :items="provinces"
            outline
            solo
            @change="onProvinceChange"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filters.city"
            no-data-text="无可用数据"
            label="城市"
            :items="cities"
            outline
            solo
            @change="onCityChange"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filters.area"
            no-data-text="无可用数据"
            label="区县"
            :items="areas"
            outline
            solo
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filters.level"
            label="客户等级"
            :items="levels"
            outline
            solo
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            v-model="filters.status"
            label="客户状态"
            :items="statuses"
            outline
            solo
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3 style="display: flex;align-items: baseline">
          <v-menu
            v-model="showStartDate"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filters.startDate"
                label="开始日期"
                readonly
                outline
                solo
                style="width:45%"
                class="xn-date"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.startDate"
              locale="zh-cn"
              @input="showStartDate = false"
            ></v-date-picker>
          </v-menu>
          <span class="mx-2">至</span>
          <v-menu
            v-model="showEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filters.endDate"
                label="结束日期"
                readonly
                outline
                solo
                style="width:45%"
                class="xn-date"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.endDate"
              locale="zh-cn"
              @input="showEndDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            v-model="filters.q"
            label="公司名称/联系人/联系方式"
            outline
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 style="display: flex;margin-bottom: 20px;">
          <v-btn color="info" style="margin-right: 5px !important;" @click="refresh">查询</v-btn>
          <v-btn color="info" @click="clearFilters">重置</v-btn>
        </v-flex>
      </v-layout>
    </v-container>



    <DataTable
      ref="dataTable"
      :headers="headers"
      :fetch-data="refreshList"
      item-key="companyId"
      sort-by="name"
      @showContractButtonClicked="showContractButtonClicked"
      @detailButtonClicked="showContractButtonClicked"
    ></DataTable>
  </div>
</template>

<script>
  import axios from "../axios";
  import DataTable from "../components/DataTable2";
  import {dateFormat} from "vue-filter-date-format";
  import {mapState, mapActions} from "vuex";

  export default {
    components: {
      DataTable
    },
    computed: {
      ...mapState({
        provinces: state => state.provinces,
        levels: state => state.levels,
        statuses: state => state.statuses
      }),
    },
    mounted(){
      //去掉全选按钮
      document.querySelectorAll('tr')[0].querySelectorAll('th')[0].innerHTML='';
    },
    data: () => ({

      headers: [
        {
          text: "公司名称",
          align: "left",
          value: "name"
        },
        {
          text: "所在地区", value: "provinceAndCityAndArea", sortable: false,
          formatter: v => (v && v.length > 20 ? v.substring(0, 20) + "..." : v)
        },
        {text: "级别", value: "level"},
        {text: "联系人", value: "contactName"},
        {text: "联系方式", value: "contactPhoneNumber"},
        {
          text: "创建时间",
          value: "createDate",
          formatter: v => dateFormat(new Date(v), "YYYY-MM-DD")
        },
        {text: "状态", value: "status"},
        {text: "操作", align: "center", value: "settings-comp", sortable: false}
      ],
      filters: {},
      cities: [],
      areas: [],
      showStartDate: false,
      showEndDate: false,
      ts: '',
      params: null,
    }),
    methods: {
      ...mapActions(["fetchCities", "fetchAreas","setLoading"]),
      refreshList(pagination, searchText, callback, failure) {
        //这种方法太笨了 --！
        let createMin = this.filters.startDate ? `gte(${this.filters.startDate})` : 'gte(1970-01-01)';
        let createMax = this.filters.endDate ? `and(lte(${this.filters.endDate}T23:59:59))` : 'and(lte(2099-12-31))';
        let ts = `?createDate=${createMin}&createDate=${createMax}`;
        this.ts = ts;
        this.params={
          params:
            {
              page: pagination.page - 1,
              size: pagination.rowsPerPage === -1 ? 2147483647 : pagination.rowsPerPage,
              sort:
                pagination.sortBy === null
                  ? null
                  : pagination.sortBy +
                  "," +
                  (pagination.descending ? "desc" : "asc"),
              companyId: this.$currentCompany ? this.$currentCompany.id : null,
              ...this.filters
            },
        };

        axios
          .get("/companies" + this.ts, this.params)
          .then(response => {
            callback(response.data.total, response.data.data);

            //去掉选择框
            setTimeout(()=>{
              document.querySelectorAll('tr').forEach((el,index)=>{
                if(index>=2){
                  document.querySelectorAll('tr')[index].querySelectorAll('td')[0].innerHTML='';
                }
              })
            },1)

          })
          .catch(reason => {
            if (failure) {
              failure(reason);
            }
          });
      },
      showContractButtonClicked(item){
        this.$router.push({
          name: "contracts",
          params: {companyId: item.companyId}
        });
      },
      refresh() {
        this.$refs.dataTable.refresh();
      },
      clearFilters() {
        this.filters = {};
        this.refresh();
      },
      onProvinceChange() {
        this.filters.city = null;
        this.filters.area = null;
        this.cities = [];
        this.areas = [];
        this.updateCities();
      },
      onCityChange() {
        this.filters.area = null;
        this.areas = [];
        this.updateAreas();
      },
      updateCities() {
        if (this.filters.province) {
          this.fetchCities({
            province: this.filters.province,
            callback: results => {
              this.cities = results;
            }
          });
        }
      },
      updateAreas() {
        if (this.filters.province && this.filters.city) {
          this.fetchAreas({
            province: this.filters.province,
            city: this.filters.city,
            callback: results => {
              this.areas = results;
            }
          });
        }
      },
    }
  };
</script>
